export * from './zoom-button.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/zoom-button/index.ts